/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from 'react-redux';
import { ActionGetCCPaperDetail } from '../../store/Actions/PatientAction';
import { PersonalDetail } from '../../store/Actions/personalDetails.actions';
import { useEffect } from 'react';
import { PatientFormDisplay } from '../../components/PatientFormDisplay';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import { Link } from 'react-router-dom';
const TwentyMinForm = () => {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const idValue = searchParams.get('id');
  const forValue = searchParams.get('for');
  const dispatch = useDispatch();
  useEffect(() => {
    if (idValue) {
      dispatch(ActionGetCCPaperDetail({ Query: `/${idValue}`, obj: undefined }));
    }
  }, []);

  const { CcPaperDetail } = useSelector(state => state?.patient);

  const handleSubmit = (payload) => {
    dispatch(
      PersonalDetail(
        {
          customerId: idValue,
          obj: JSON.stringify(payload),
        },
        Res => {
          if (Res?.data?.statusCode === 200) {
            if (forValue == '125') {
              window.history.back(); // go to previous page
            } else {
              window.location.href = `/patient-list?page=1`;
            }
          } else if (Res?.data?.statusCode === 400) {
            console.error('Validation errors:', Res?.data?.errors);
          }

        }
      )
    );
  };

  return (<>
    <Header />
    <Sidebar id="menu-item15" id1="menu-items15" activeClassName="vertical-form" />
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Detailed Health Assessment form </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12 m-auto">
              <div className="card-box">
                <PatientFormDisplay patientData={CcPaperDetail} onSubmit={handleSubmit} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  </>)
}

export default TwentyMinForm;
